import { C as p } from "./component-B88NZlIm.js";
import { d as g } from "./utilities-D-QcnR4L.js";
class H extends p {
  #e = null;
  connectedCallback() {
    (super.connectedCallback(),
      (this.sectionId = this.getAttribute("section-id")),
      this.addEventListener("change", this.#r, { signal: this.signal }),
      window.addEventListener("popstate", this.#i, { signal: this.signal }));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.removeEventListener("change", this.#r),
      window.removeEventListener("popstate", this.#i),
      this.#t !== void 0 && (clearTimeout(this.#t), (this.#t = void 0)));
  }
  #r = (n) => {
    const t = this.querySelector("form");
    if (!t) return;
    if (n.target.closest("price-facet-component")) {
      (clearTimeout(this.#t), (this.#t = setTimeout(() => this.#o(t), 500)));
      return;
    }
    this.#o(t);
  };
  #t;
  #o(n) {
    const t = new FormData(n),
      e = new URLSearchParams();
    for (const [c, o] of t.entries()) o && e.append(c, o);
    const i = `${n.action}?${e.toString()}`;
    this.#n(i);
  }
  #i = () => {
    this.#n(window.location.href, !1);
  };
  async #n(n, t = !0) {
    (this.#e && this.#e.abort(), (this.#e = new AbortController()), this.#c(!0));
    try {
      const e = new URL(n, window.location.origin);
      e.searchParams.set("section_id", this.sectionId);
      const i = await fetch(e.toString(), { signal: this.#e.signal });
      if (!i.ok) throw new Error("Network response was not ok");
      const c = await i.text();
      (t && history.pushState({}, "", n), this.#s(c));
    } catch (e) {
      e.name !== "AbortError" && console.error("Facets fetch error:", e);
    } finally {
      (this.#c(!1), (this.#e = null));
    }
  }
  #s(n) {
    const e = new DOMParser().parseFromString(n, "text/html"),
      i = e.querySelector("[data-products-grid]"),
      c = document.querySelector("[data-products-grid]");
    i && c && (c.innerHTML = i.innerHTML);
    const o = e.querySelector(".active-filters--inline[data-active-filters]"),
      l = document.querySelector(".active-filters--inline[data-active-filters]"),
      h = document.querySelector(".filter-bar__left");
    if (o && l) l.innerHTML = o.innerHTML;
    else if (o && !l && h) {
      const r = h.querySelector(".facets-toggle__button");
      r
        ? r.insertAdjacentHTML("afterend", o.outerHTML)
        : h.insertAdjacentHTML("afterbegin", o.outerHTML);
    } else !o && l && l.remove();
    const u = e.querySelector(".filter-bar ~ [data-active-filters]"),
      d = document.querySelector(".filter-bar ~ [data-active-filters]"),
      w = document.querySelector(".filter-bar");
    u && d
      ? (d.innerHTML = u.innerHTML)
      : u && !d && w
        ? w.insertAdjacentHTML("afterend", u.outerHTML)
        : !u && d && d.remove();
    const y = e.querySelector("#filter-drawer [data-active-filters]"),
      S = document.querySelector("#filter-drawer [data-active-filters]");
    y && S && (S.innerHTML = y.innerHTML);
    const L = e.querySelector("#filter-drawer form"),
      C = document.querySelector("#filter-drawer form");
    if (L && C) {
      const r = L.querySelectorAll('input[type="checkbox"]'),
        s = C.querySelectorAll('input[type="checkbox"]');
      r.forEach((a) => {
        const f = Array.from(s).find((M) => M.name === a.name && M.value === a.value);
        f && (f.checked = a.checked);
      });
    }
    const b = e.querySelectorAll(".facets-toggle__count"),
      m = document.querySelectorAll(".facets-toggle__count");
    b.length === 0 && m.length > 0
      ? m.forEach((r) => r.remove())
      : b.forEach((r, s) => {
          if (m[s]) m[s].textContent = r.textContent;
          else {
            const a = document.querySelectorAll(".facets-toggle__button")[s],
              f = document.querySelectorAll(".drawer-header__title")[s - 1];
            a
              ? a.insertAdjacentHTML("beforeend", r.outerHTML)
              : f && f.insertAdjacentHTML("beforeend", r.outerHTML);
          }
        });
    const q = e.querySelector("[data-products-count]"),
      k = document.querySelector("[data-products-count]");
    q && k && (k.textContent = q.textContent);
    const A = e.querySelector("[data-pagination]"),
      T = document.querySelector("[data-pagination]");
    (A && T && (T.innerHTML = A.innerHTML), this.#a());
  }
  #a() {
    const n = ["facet-remove-component", "facets-form-component", "price-facet-component"];
    this.querySelectorAll(n.join(",")).forEach((e) => {
      window.customElements?.upgrade(e);
    });
  }
  #c(n) {
    const t = document.querySelector("[data-products-grid]");
    t && (t.classList.toggle("opacity-50", n), t.classList.toggle("pointer-events-none", n));
  }
  clearAll(n) {
    const t = n || window.location.pathname;
    this.#n(t);
  }
}
class E extends p {
  connectedCallback() {
    (super.connectedCallback(),
      (this.minInput = this.querySelector('input[name*="filter.v.price.gte"]')),
      (this.maxInput = this.querySelector('input[name*="filter.v.price.lte"]')),
      this.minInput && this.minInput.addEventListener("input", this.#e),
      this.maxInput && this.maxInput.addEventListener("input", this.#e));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.minInput && this.minInput.removeEventListener("input", this.#e),
      this.maxInput && this.maxInput.removeEventListener("input", this.#e));
  }
  #e = (n) => {
    const t = n.target;
    t.value = t.value.replace(/[^0-9.]/g, "");
  };
}
class F extends p {
  connectedCallback() {
    (super.connectedCallback(), this.addEventListener("click", this.#e));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(), this.removeEventListener("click", this.#e));
  }
  #e = (n) => {
    n.preventDefault();
    const t = this.getAttribute("href");
    if (!t) return;
    let e = this.closest("facets-form-component");
    (e || (e = document.querySelector("facets-form-component")), e instanceof H && e.clearAll(t));
  };
}
g("facets-form-component", H);
g("price-facet-component", E);
g("facet-remove-component", F);
